export type MenuItemRibbonProps = {
  itemId: number;
  almostGone?: boolean;
  className?: string;
  isDishDetails?: boolean;
};

export enum RibbonType {
  AlmostGone = "Almost Gone!",
}
